{
  "orders": {
    "title": "Production Plan",
    "subtitle": "Plan and release production runs for weight-based (FMCG-style) items.",
    "addNew": "New Plan",
    "columns": {
      "orderNumber": "Plan No",
      "warehouse": "Warehouse",
      "plannedStart": "Planned Start",
      "plannedEnd": "Planned End",
      "status": "Status",
      "planned": "Planned",
      "produced": "Produced",
      "remaining": "Remaining"
    },
    "release": "Release",
    "cancel": "Cancel",
    "close": "Close Plan",
    "closeDialog": {
      "title": "Close plan {{plan}} short",
      "explain": "Use this when a plan will never reach its planned quantity — the material ran out, or the run was stopped. The plan stays in reporting as closed-short, separate from one that was completed. A tiny leftover that is simply too small to make another unit needs no action: those lines complete on their own.",
      "shortfall": "{{produced}} of {{planned}} — short by {{short}}",
      "reason": "Reason for closing short",
      "reasonHelper": "Required — this is the record of why production stopped early."
    },
    "dialog": {
      "title": "Production Plan",
      "warehouse": "Warehouse",
      "zone": "Zone",
      "zoneNeedsWarehouse": "Choose a warehouse first.",
      "plannedStartDate": "Planned Start Date",
      "plannedEndDate": "Planned End Date",
      "remarks": "Remarks",
      "lines": "Materials",
      "addLine": "Add Material",
      "material": "Material",
      "plannedQty": "Planned Qty",
      "plannedQtyIn": "Planned ({{unit}})",
      "planBasis": "Plan By",
      "basisWeight": "Weight",
      "basisQuantity": "Quantity",
      "unitPcs": "PCS",
      "location": "Location (optional)",
      "batchNo": "Batch No. (optional)",
      "notConfiguredHint": "Finished and semi-finished items with Weigh & Label enabled on the Item Master are shown.",
      "tabBom": "BOM Based",
      "tabDirect": "Direct",
      "bomExplain": "The output item's Active BOM is exploded into the materials this plan consumes. On release a pick list is created, and the plan can only be weighed at the kiosk once every input has been issued from stock.",
      "outputMaterial": "Output Item",
      "outputMaterialHint": "Finished and semi-finished items with Weigh & Label enabled that have an Active BOM.",
      "noActiveBoms": "No Weigh & Label item has an Active BOM yet — map one under Masters → BOM, or use the Direct tab.",
      "willConsume": "Will consume, per BOM {{bom}}"
    }
  },
  "putaway": {
    "title": "FG Putaway",
    "subtitle": "Finished output from the Weighing Kiosk — read-only. Plan-based weighings only become real, dispatchable stock once confirmed on Job Completion; Direct weighings are stock immediately.",
    "columns": {
      "barcode": "Barcode",
      "material": "Material",
      "batch": "Batch No.",
      "expiry": "Expiry Date",
      "qty": "Qty",
      "warehouse": "Warehouse",
      "zone": "Zone",
      "produced": "Produced",
      "status": "Status",
      "stockStatus": "Stock Status"
    },
    "stockPending": "Pending",
    "stockPosted": "Posted"
  },
  "jobCompletion": {
    "title": "Job Completion",
    "subtitle": "Confirm a production plan's weighings, item-wise, to post them to stock. Printing a label at the Kiosk no longer moves stock by itself for a plan-based weighing.",
    "nothingPending": "Nothing is waiting on job completion right now.",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "material": "Material",
    "pendingQty": "Pending Qty",
    "entryCount": "Weighings",
    "confirmButton": "Confirm Job ({{count}})",
    "confirming": "Confirming...",
    "barcode": "Barcode",
    "weight": "Weight",
    "produced": "Produced",
    "close": "Close"
  },
  "issue": {
    "title": "Weigh & Label Material Issue",
    "subtitle": "Consume the materials a BOM-based plan needs before it can be weighed.",
    "selectPickList": "Pick List",
    "destinationZone": "Produces into: {{zone}}",
    "nothingPending": "No plan is waiting on material. BOM-based plans appear here once released.",
    "history": "Issue history",
    "scanBarcode": "Scan Barcode",
    "scanBarcodeHelper": "Scan each label — the line confirms itself and moves to the top.",
    "scannedOfTotal": "{{scanned}}/{{total}}",
    "scanned": "scanned",
    "expectedBarcode": "Barcode: {{barcode}}",
    "noBarcodeBlocked": "No labelled stock allocated for this line — relabel and put the stock away, then regenerate the pick list.",
    "location": "Location",
    "batch": "Batch",
    "required": "Required",
    "remaining": "{{qty}} left",
    "warehouseStock": "Warehouse: {{qty}}",
    "locationStock": "Location: {{qty}}",
    "qtyToIssue": "Qty to issue",
    "overStock": "Only {{qty}} available",
    "issuing": "Issuing…",
    "postIssue": "Issue Material",
    "failed": "The issue could not be posted.",
    "columns": {
      "issueNumber": "Issue No",
      "plan": "Plan",
      "warehouse": "Warehouse",
      "date": "Issued",
      "issuedBy": "Issued By",
      "lines": "Lines",
      "totalIssued": "Total Qty"
    }
  },
  "kiosk": {
    "title": "Weigh & Label Kiosk",
    "subtitle": "Capture each weighing against the item's tolerance, then print its label.",
    "manualEntryBadge": "Manual Entry Mode — hardware agent not connected",
    "liveModeBadge": "Live capture — {{station}} · scale on {{port}} · printer {{printer}}. Place material on the scale; the label prints automatically once the weight settles in tolerance.",
    "scaleOffline": "Hardware agent is running, but the scale on {{port}} is not responding. {{error}}",
    "stable": "STABLE",
    "settling": "SETTLING…",
    "awaitingMaterial": "Waiting for material on the scale…",
    "removeMaterial": "Remove the material — the next label arms once the scale clears.",
    "kioskMode": "Kiosk Mode",
    "exitKioskMode": "Exit Kiosk Mode",
    "labelPreview": "Label preview — prints on capture",
    "labelPrinted": "Label printed",
    "previewBarcode": "(barcode on capture)",
    "directPrint": "prints directly to {{printer}}",
    "printFailed": "The weighing was captured, but the label could not be printed.",
    "bridgeUnavailableForPrint": "The Hardware Bridge on this station is not reachable, so the label could not be sent to the printer. Start the agent and reprint from Recent Labels.",
    "printViaBrowser": "Print via browser",
    "imagesSkipped": "Label printed, but {{count}} image/logo element was not sent — direct printing supports text, barcodes, QR and shapes.",
    "planOrDirect": "Production Plan / Direct",
    "direct": "Direct (no plan)",
    "material": "Material",
    "targetWeight": "Target Weight",
    "minimum": "Minimum",
    "maximum": "Maximum",
    "batchNo": "Batch No.",
    "batchAuto": "Auto",
    "expiryDate": "Expiry Date",
    "currentWeight": "Current Weight",
    "enterWeight": "Enter Weight",
    "validate": "Validate",
    "confirmAndPrint": "Confirm & Print",
    "reset": "Reset",
    "statusValid": "VALID",
    "statusUnderweight": "UNDERWEIGHT",
    "statusOverweight": "OVERWEIGHT",
    "toleranceRange": "Allowed range {{min}}–{{max}} {{uom}}",
    "planProgress": "Plan Progress",
    "producedOfPlanned": "{{produced}} / {{planned}} {{uom}}",
    "overPlanWarning": "This weighing exceeds the plan's remaining quantity.",
    "overPlanBlocked": "Production is blocked past plan for this material.",
    "overrideReason": "Supervisor override reason",
    "hardwareStation": "Hardware Station",
    "noStation": "No station — hardware agent not connected",
    "stationUnmatched": "The hardware agent reports station code \"{{code}}\", which matches no Hardware Station in this company. Weighings will be recorded without a station until the codes match — fix it in Hardware Configuration, or in the agent's appsettings.json.",
    "chipLive": "LIVE · {{port}}",
    "chipScaleOffline": "SCALE OFFLINE",
    "chipManual": "MANUAL ENTRY",
    "selectItemFirst": "Select a plan or item to begin",
    "remaining": "remaining",
    "unitPcs": "PCS",
    "plannedQty": "Plan Qty",
    "producedQty": "Produced",
    "remainingQty": "Remaining",
    "recentLabels": "Recent labels",
    "recentLabelsHint": "Reprint goes straight to the printer — no dialog.",
    "noRecentLabels": "No weighings captured yet.",
    "reprinting": "Printing…",
    "reprintReasonKiosk": "Reprinted from Weighing Kiosk",
    "noTemplateForEntry": "That item has no Active label template assigned, so its label cannot be reprinted.",
    "reconnectScale": "Reconnect scale",
    "reconnecting": "Reconnecting…",
    "scaleReleased": "The port {{port}} has been released — the scale is not being read. Reconnect to resume live capture.",
    "modeAuto": "AUTO",
    "modeManual": "MANUAL",
    "overrideWeight": "Weight",
    "manualReady": "Press Confirm & Print to produce this label.",
    "manualReadyEnter": "Press Enter to print this label.",
    "manualOutOfTolerance": "Weight is outside the item's tolerance — adjust the material or type a corrected weight.",
    "printerMissing": "PRINTER NOT FOUND",
    "printerQueued": "{{count}} job(s) waiting in the queue",
    "printerOffline": "Printer problem — {{problem}}",
    "destination": "Stock posts to {{warehouse}} · {{location}}",
    "noLocation": "no location",
    "noWarehouseResolved": "No warehouse to post to — select a production plan, or set a Default Warehouse for this item on the Item Master.",
    "entryConfirmed": "Weighing captured — {{barcode}} — label printed",
    "replaceMaterialHint": "Replace the material on the scale — the next label prints automatically once the next weighing reaches tolerance.",
    "noAutoPrintTemplate": "The weighing was captured, but no label could be printed — this item has no Active label template assigned. Assign one on Masters → Item Master → this item → Weigh & Label tab, then reprint this weighing from the Label Reprint screen.",
    "noAutoPrintTemplateHint": "No label template assigned — set one on the Item Master's Weigh & Label tab, or labels won't print automatically for this item.",
    "autoPrintDisabled": "The weighing was captured, but Automatic Label Printing is switched off for this item on the Item Master, so no label was printed.",
    "autoPrintDisabledHint": "Automatic Label Printing is switched off for this item — weighings are captured without printing a label.",
    "noToleranceConfigured": "This material has no Weigh & Label tolerance configured on the Item Master."
  },
  "printing": {
    "title": "Weigh & Label Reprint",
    "subtitle": "Reprint a label for a weighing already captured at the kiosk.",
    "reprintOnlyNotice": "Reprint only. The first label always prints automatically at the Weighing Kiosk the moment the weighing meets the item's tolerance — this screen is for damaged, lost, or mis-fed labels, and always re-prints the same barcode that weighing was created with.",
    "entry": "Weighing (barcode)",
    "barcode": "Barcode",
    "template": "Label Template",
    "print": "Print",
    "reprint": "Reprint",
    "reprintReason": "Reprint reason",
    "reprintReasonHelper": "Required — recorded against the reprint in the print history.",
    "directPrintNotice": "Hardware Bridge connected — reprints go straight to {{printer}} with no print dialog.",
    "browserPrintNotice": "No Hardware Bridge on this PC, so reprints fall back to the browser's print dialog. Run the agent on the station for direct printing.",
    "printedDate": "Printed",
    "printer": "Printer",
    "printedBy": "Printed By",
    "reprintColumn": "Reprint",
    "neverPrinted": "This weighing has no print history yet — nothing to reprint. Its first label prints at the kiosk.",
    "selectEntryHint": "Select a weighing to see its print history and reprint its label.",
    "history": "Print History"
  },
  "hardware": {
    "title": "Weighing Stations",
    "subtitle": "The named weighing points each capture is recorded against.",
    "codeMatchNotice": "A station's Code must match the Station:Code set in that PC's Hardware Bridge agent — that is how a weighing is linked to the station that produced it. The scale's COM port and the printer name are configured in the agent on the station PC, not here.",
    "station": {
      "name": "Station Name",
      "code": "Station Code",
      "codeHelper": "Identifies the station. Agents normally identify themselves by PC name, so this only has to match an agent's Station:Code if that PC was pinned to a specific station.",
      "plantArea": "Plant / Area",
      "machine": "PC",
      "hardwareSection": "Hardware",
      "blankMeansLocal": "Leave a field blank to let that PC decide: no COM port means auto-detect the single adapter, no printer name means that PC's Windows default. Changes here reach the agent within one heartbeat — no need to visit the machine.",
      "serialPort": "COM Port",
      "autoDetect": "auto-detect",
      "windowsDefault": "Windows default",
      "baudRate": "Baud Rate",
      "dataBits": "Data Bits",
      "parity": "Parity",
      "stopBits": "Stop Bits",
      "printerName": "Printer Name (as Windows shows it)",
      "stableReadings": "Stable Readings",
      "stableReadingsHint": "Identical readings that count as settled, for scales that send no stability flag.",
      "heartbeatSeconds": "Heartbeat (seconds)",
      "parseRegex": "Custom Frame Pattern",
      "parseRegexHint": "Leave blank unless this scale's output can't be read by the standard parser."
    },
    "enrollment": {
      "title": "Agent Enrollment Key",
      "explain": "One key for the whole plant — you do not need a separate key per PC. Put this same key in every station's agent config, unchanged. Each agent identifies itself by its Windows PC name and registers its own station on first contact, so a thirty-station rollout is one file copied thirty times with nothing edited.",
      "perStationNote": "Individual per-station keys (the button on each row) are optional, and only worth issuing when you want to revoke one station on its own.",
      "notGenerated": "No key generated yet",
      "generate": "Generate Key",
      "rotate": "Rotate Key",
      "rotateWarning": "Rotating this key stops every existing agent reporting until each one is updated with the new value."
    },
    "add": "Add Station",
    "downloadAgent": "Download Agent",
    "downloadingAgent": "Preparing…",
    "downloadAgentHint": "Download the Hardware Bridge agent installer to set up a station PC. Copy it to the station, unzip, set Station.Code in appsettings.json, and run it.",
    "downloadAgentUnavailable": "No agent package has been staged on this server yet.",
    "edit": "Edit",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "status": "Status",
    "generateKey": "Individual Key",
    "keyIssuedTitle": "Individual key for station {{code}}",
    "keyIssuedWarning": "You normally do NOT need this. Every station can share the one Agent Enrollment Key above — issue an individual key only when you want to revoke or isolate this single station without affecting the others.",
    "keyIssuedWhere": "If you do use it, paste it into that station PC's Hardware Bridge appsettings.json under Server:ApiKey (replacing the enrollment key) and restart the agent. Copy it now — it is shown only once.",
    "copyKey": "Copy",
    "done": "Done"
  },
  "monitor": {
    "title": "Hardware Monitor",
    "subtitle": "Every weighing station, the PC it runs on, and whether its scale and printer are working right now.",
    "summaryOnline": "{{count}} of {{total}} stations reporting",
    "summaryProblems": "{{count}} with a hardware problem",
    "autoRefresh": "Refreshes every {{seconds}}s",
    "noStations": "No weighing stations yet. Add one under Weighing Stations, generate its agent key, and configure that key in the station PC's Hardware Bridge.",
    "noAgentKey": "No agent key issued — this station cannot report. Generate one on the Weighing Stations screen.",
    "agentOnline": "ONLINE",
    "agentOffline": "OFFLINE",
    "scaleConnected": "Scale OK",
    "scaleReleased": "Released",
    "scaleDown": "No scale",
    "printerReady": "Ready",
    "printerDown": "Printer down",
    "queuedJobs": "{{count}} print job(s) stuck in the queue",
    "todayWeighings": "Weighings today",
    "todayLabels": "Labels today",
    "lastSeen": "Last seen",
    "neverReported": "never",
    "secondsAgo": "{{count}}s ago",
    "minutesAgo": "{{count}}m ago",
    "hoursAgo": "{{count}}h ago"
  },
  "materialTab": {
    "title": "Weigh & Label",
    "enabled": "Weigh & Label Enabled",
    "standardWeight": "Standard Weight",
    "minWeight": "Minimum Weight",
    "maxWeight": "Maximum Weight",
    "weightUom": "Weight Unit",
    "toleranceType": "Tolerance Type",
    "toleranceTypeFixed": "Fixed Value",
    "toleranceTypePercentage": "Percentage",
    "toleranceValue": "Tolerance Value",
    "stabilityDurationSeconds": "Stability Duration (seconds)",
    "autoGenerateBarcode": "Auto-Generate Barcode",
    "autoPrintLabel": "Auto-Print Label",
    "labelTemplate": "Label Template",
    "labelTemplateHelper": "The label the kiosk prints automatically for each weighing of this item. Generic templates and templates assigned to Weigh & Label in the Label Designer are offered here.",
    "defaultHardwareStation": "Default Hardware Station"
  }
}
